import dataroomConfig from '@/dataroom/application/config/config';

export default dataroomConfig;
